import { useState, useEffect, useMemo, useContext, useRef } from 'react';
import _ from 'underscore';
import services from '../../../services/services';
import { Urls } from '../../../services/Urls';
import { callautopopulate } from '../../../services/callautopop';
import { ToastContext } from '../../../context/ToastContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from '../../Common/useCommon';


export const useMasterconfig = () => {
    const { showSuccess, showInfo, showError, } = useContext(ToastContext);
    const [showCreatePopup, setShowCreatePopup] = useState(false);
    const [showDelete, setshowDelete] = useState(false);
    const currentData = useRef([])
    const isColDelete = useRef(false)
    const [mastersList, setMastersList] = useState([]);
    const [listLoader, setlistLoader] = useState(false);
    const [tableNameOptions, setTableNameOptions] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const groupOption = useRef([])
    const [isNewMaster, setisNewMaster] = useState(false);
    const [currentMaster, setcurrentMaster] = useState(null)
    const [isValueChanged, setisValueChanged] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [columnDefs] = useState([
        {
            field: "column_id",
            headerName: "SrNo.",
            width: "30%",
            minWidth: 70,
            suppressHeaderMenuButton: true,

        },
        {
            field: "column_name",
            headerName: "Column Name",
            width: "30%",
            minWidth: 150,
            suppressHeaderMenuButton: true,

        },
        {
            field: "column_display_name",
            headerName: "Display Name",
            minWidth: 150,
            width: "30%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellEditor: 'agTextCellEditor',
            tooltipValueGetter: () => "double click to edit",
            editable: true,
        },
        {
            field: "column_display_id",
            headerName: "Display Order",
            minWidth: 90,
            width: "12%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellEditor: 'agNumberCellEditor',
            cellEditorParams: {
                min: 0,
            },
            tooltipValueGetter: () => "double click to edit",
            editable: true,
        },
        {
            field: "descriptions",
            headerName: "Description",
            minWidth: 90,
            width: "30%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellEditor: 'agTextCellEditor',
            tooltipValueGetter: () => "double click to edit",
            editable: true,
        },
        {
            field: "alignment",
            headerName: "Align",
            minWidth: 70,
            width: "12%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellEditor: "agSelectCellEditor",
            editable: true,
            cellEditorParams: {
                values: ["l", "r", "c"],
            },
        },
        {
            field: "column_width",
            headerName: "Width",
            minWidth: 70,
            width: "12%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellEditor: 'agNumberCellEditor',
            cellEditorParams: {
                min: 0,
            },
            editable: true,
            tooltipValueGetter: () => "double click to edit",
        },
        {
            field: "is_active",
            headerName: "Active",
            minWidth: 70,
            width: "15%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellEditor: "agCheckboxCellEditor",
            editable: (params) => {
                return params.data.column_display_name && params.data?.column_display_id !== 0 || params.data?.column_display_id !== null;
            },
        },
        {
            field: "column_id",
            headerName: "Delete",
            minWidth: 100,
            width: "15%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                return (
                    <div>
                        <span><FontAwesomeIcon icon="fa-solid fa-trash" onClick={() => { setshowDelete(true); isColDelete.current = true; currentData.current = params }} /></span>
                    </div>
                )
            }
        }
    ]);
    const [icons, seticons] = useState(true)
    const [rowData, setrowData] = useState([]);
    const [loader, setLoader] = useState(false)
    const gridDatas = useRef([])
    const gridRefs = useRef(null);
    const [showGrid, setshowGrid] = useState(false);
    const [currentVisibleMaster, setcurrentVisibleMaster] = useState('');
    const master = useRef({});
    const [masterComponent, setmasterComponent] = useState(false);
    const [isMasterCall, setisMasterCall] = useState(false);
    const [testData, setTestData] = useState([]);
    const [lastEditedRow, setLastEditedRow] = useState(null);
    const [expandedGroups, setExpandedGroups] = useState([]);
    const [sideOpen, setSideOpen] = useState([]);
    const [tableData, setTableData] = useState({
        object_id: {},
        display_name: "",
        entity_group_id: {},
        is_active: false,
        descriptions: ""
    })
    const gridApiRef = useRef(null);
    const { useDebounce } = useCommon()

    useEffect(() => {
        getTablesList();
        getTableEntityList()
        sessionStorage.removeItem("entity_group")
        callautopopulate("entity_group").then(res => {
            const group = res?.entity_group?.sort((a, b) => a?.group_name?.localeCompare(b?.group_name));
            groupOption.current = group
            setGroupOptions(group)
        })
        // eslint-disable-next-line
    }, [])


    const onCellValueChanged = (event) => {
        const { rowIndex } = event;

        if (lastEditedRow !== undefined && lastEditedRow !== null && lastEditedRow !== rowIndex) {
            if (!_.isEqual(testData[lastEditedRow], rowData[lastEditedRow])) {
                handleUpsertTableEntityColumn(rowData[lastEditedRow], lastEditedRow);
                setLastEditedRow(null)
            }
        }
        setLastEditedRow(rowIndex);
    };



    const handleClickOutside = (event) => {
        if (gridApiRef.current) {
            gridApiRef.current.stopEditing();
        }
        if (lastEditedRow !== undefined && lastEditedRow !== null) {
            if (!_.isEqual(testData[lastEditedRow], rowData[lastEditedRow])) {

                handleUpsertTableEntityColumn(rowData[lastEditedRow], lastEditedRow);
                setLastEditedRow(null)
            }
        }
    };


    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [lastEditedRow]);

    const getTableEntityList = async (data) => {
        setlistLoader(true)
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETTABLEENTITYLIST"));
            if (res) {
                const tabledata = _.uniq(res?.body?.data?.table_list);
                const grouped = tabledata.reduce((acc, item) => {
                    acc[item.group_name] = acc[item.group_name] || [];
                    acc[item.group_name].push(item);
                    return acc;
                }, {});
                setMastersList(grouped)
                if (!_.isEmpty(data)) {
                    setTableData({
                        object_id: { name: data.table_name, object_id: data.object_id },
                        display_name: data?.display_name,
                        entity_group_id: _.findWhere(groupOption.current, { entity_group_id: data.entity_group_id }),
                        is_active: data?.is_active,
                        descriptions: data?.descriptions
                    })
                    setisValueChanged(false)
                }
                setlistLoader(false)

            }
        } catch (error) {
            console.error("Error getting tables list: ", error);
            setlistLoader(false)
        }
    }


    // handle on change event for add table 
    const handleChange = (e, check) => {
        if (check) {
            setTableData((prev) => ({ ...prev, [e.target.name]: e.target.checked }))
        } else {
            setTableData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
        setisValueChanged(true)
    }

    // this function handel the add and edit table row
    const handleUpsertTableEntityColumn = async (currentRow, editedRow) => {
        let currentRowData = { ...currentRow };
        const displayNameFilled = (currentRowData.column_display_name && currentRowData.column_display_name.trim() !== "" && testData[editedRow]["column_display_name"] === null);
        const displayOrderFilled = (currentRowData.column_display_id !== null && currentRowData.column_display_id > 0) && (testData[editedRow]["column_display_id"] === null || testData[editedRow]["column_display_id"] === 0);
        if (displayNameFilled && displayOrderFilled && !testData[editedRow]["is_active"]) {
            currentRowData.is_active = true;
            currentRowData.alignment = 'l'
        }
        if (currentRowData?.column_display_name === null && (currentRowData?.column_display_id === 0 || currentRowData?.column_display_id === null)) {
            if (gridRefs.current.props.rowData[editedRow].hasOwnProperty("alignment")) {
                gridRefs.current.props.rowData[editedRow]["alignment"] = null
            }
            const rowNode = gridRefs.current.api.getDisplayedRowAtIndex(editedRow);
            rowNode.setData([...rowData][editedRow]);
            return
        } else if (currentRowData?.column_display_name !== null && (currentRowData?.column_display_id === 0 || currentRowData?.column_display_id === null)) {
            showInfo('Info', 'Display Order Cannot be Empty')
            return
        }
        else if ((currentRowData?.column_display_name === null || currentRowData?.column_display_id === 0 || currentRowData?.column_display_id === null) && currentRowData?.is_active) {
            showInfo('Info', currentRowData?.column_display_name === null ? 'Display Name Cannot be empty' : currentRowData?.column_display_id === null ? 'Display Order Cannot be Empty' : currentRowData?.column_display_id === 0 ? 'Display Order Cannot be Zero' : '')
            if (gridRefs.current.props.rowData[editedRow].hasOwnProperty("is_active")) {
                gridRefs.current.props.rowData[editedRow]["is_active"] = false
            }
            const rowNode = gridRefs.current.api.getDisplayedRowAtIndex(editedRow);
            rowNode.setData([...rowData][editedRow]);
            return
        }

        try {
            const payload = {
                "entity_metadata_id": currentRowData?.entity_metadata_id,
                "column_id": currentRowData?.column_id,
                "column_display_name": currentRowData?.column_display_name,
                "column_display_id": currentRowData?.column_display_id,
                "alignment": currentRowData?.alignment,
                "column_length": currentRowData?.column_length,
                "column_width": currentRowData?.column_width || 100,
                "descriptions": currentRowData?.descriptions?.trim() || "",
                "is_active": currentRowData?.is_active,
            }

            const res = await services.getInvokeRemote("POST", Urls("UPSERTTABLEENTITYCOLUMN"), payload);
            if (res.body.data) {
                showSuccess('Success', res.body.message)
                setTestData(JSON.parse(JSON.stringify(rowData)))
                if (testData[editedRow]["is_active"] !== currentRowData["is_active"]) {
                    if (gridRefs.current.props.rowData[editedRow].hasOwnProperty("is_active")) {
                        gridRefs.current.props.rowData[editedRow] = currentRowData
                    }
                    const rowNode = gridRefs.current.api.getDisplayedRowAtIndex(editedRow);
                    rowNode.setData([...rowData][editedRow]);
                }
            }
        } catch (error) {
            setrowData(JSON.parse(JSON.stringify(testData)))
            console.error("Error getting tables list: ", error?.response?.data);
            showError("Error", error?.response?.data?.errorMessage);

        }
    }


    const getTablesList = async () => {
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETNEWTABLESLIST"));
            if (res) {
                const tabledata = res?.body?.data?.table_list;
                setTableNameOptions(tabledata);
            }
        } catch (error) {
            console.error("Error getting tables list: ", error);
        }
    }

    const handleCreateMaster = () => {
        setcurrentMaster(null)
        setShowCreatePopup(true);

    };

    const handleUpsertMaster = async () => {
        if (!isValueChanged) {
            showInfo("Info", "No Changes Made");
            return;
        }
        if (_.isEmpty(tableData?.object_id) && !isNewMaster) {
            showInfo("Info", "Please select a master");
            return;
        } else if (tableData?.display_name === "") {
            showInfo("Info", "Display name cannot be empty");
            return;
        } else if (_.isEmpty(tableData.entity_group_id)) {
            showInfo("Info", "Please select a group");
            return;
        }
        else if (tableData?.descriptions === '') {
            showInfo("Info", "Description  cannot be empty");
            return;
        }
        try {
            const payload = {
                object_id: tableData?.object_id.object_id,
                display_name: tableData?.display_name,
                entity_group_id: tableData.entity_group_id?.entity_group_id,
                is_active: tableData?.is_active,
                descriptions: tableData?.descriptions
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTABLEENTITY"), payload)
            if (res) {
                showSuccess("Success", res.body.message);
                setcurrentVisibleMaster((prevState) => ({
                    ...prevState,
                    display_name: tableData?.display_name
                }));
                getTablesList();
                getTableEntityList()
                onHide();
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
            console.error("Error saving Masters data: ", error);
        }
    };

    const deleteMaster = async (data) => {
        try {
            const payload = {
                "entity_metadata_id": data.entity_metadata_id
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETETABLEENTITY"), payload);
            if (res?.body?.data) {
                setshowDelete(false)
                showSuccess("Success", res.body.message);
                getTableEntityList()
                setisMasterCall(false)
                setshowGrid(false)
                setmasterComponent(false)


            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
            console.error("Error Deleting Master: ", error);
        }
    }

    const renameMaster = (currentSelected) => {
        setcurrentMaster(currentSelected?.table_name)
        setShowCreatePopup(true);
        setisNewMaster(true)
        getTableEntityList(currentSelected)
    }

    // create table hide
    const onHide = () => {
        setisNewMaster(false)
        setShowCreatePopup(false)
        setTableData({
            object_id: {},
            display_name: "",
            entity_group_id: {},
            is_active: false,
            descriptions: ""
        })
    }


    const handleColumnList = async (rowdata) => {
        setisMasterCall(false)
        setmasterComponent(true)
        setisMasterCall(true)
        setshowGrid(false)
        seticons(true)
        setcurrentVisibleMaster(rowdata)
        master.current = rowdata
    }

    const handleComponent = () => {
        setmasterComponent(true)
        setshowGrid(false)
        setisMasterCall(true)
    }

    const configApiCall = async () => {
        let rowNumber = 1
        let gridData = []
        try {
            setLoader(true)
            const payload = {
                object_id: master.current.object_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETTABLEENTITYCOLUMNLIST"), payload);
            if (res?.body?.data?.table_columns) {
                setLoader(false)

                res?.body?.data?.table_columns.map(data => {
                    let obj = {
                        sr_no: rowNumber++,
                        column_id: data.column_id,
                        column_display_name: data.column_display_name,
                        column_name: data.name,
                        column_display_id: data.column_display_id,
                        "is_active": data.is_active,
                        "alignment": data.alignment,
                        "entity_metadata_id": data.entity_metadata_id,
                        "column_length": data.column_length,
                        "column_width": data.column_width,
                        "descriptions": data.descriptions,
                    }

                    if (!_.find(gridData, obj)) {
                        gridData.push(obj)
                    }
                })
                setrowData(gridData)
                setTestData(deepClone(gridData));
                // setTestData(JSON.parse(JSON.stringify(gridData)))
                gridDatas.current = [...gridData]
            }
        } catch (error) {
            setLoader(false)
            console.error("Error getting tables list: ", error);
        }
    }

    function deepClone(obj) {
        if (!obj || typeof obj !== 'object') {
            return obj;
        }
        if (Array.isArray(obj)) {
            return _.map(obj, deepClone);
        }
        return _.extend({}, obj, _.mapObject(obj, deepClone));
    }

    const handleMasterConfig = () => {
        setmasterComponent(false)
        setshowGrid(true)
        setisMasterCall(false)
        configApiCall()
    }

    const handleConfigComponent = (data) => {
        setshowGrid(true)
        setisMasterCall(false)
        configApiCall()
        seticons(false)
        data === 'No Config' ? seticons(false) : seticons(true)
        setmasterComponent(false)
    }

    const deleteColumn = async (rowdata) => {
        try {
            const payload = {
                "entity_metadata_id": rowdata.data.entity_metadata_id,
                "column_id": rowdata.data.column_id,
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETETABLEENTITYCOLUMN"), payload);
            if (res?.body?.data) {
                showSuccess("Success", res.body.message);
                configApiCall()
            }
            else {
                showError('Error', res.body.errorMessage)
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
            console.error("Error Deleting Master: ", error);
        }
    }



    const toggleGroup = (groupName) => {
        setExpandedGroups((prev) =>
            prev.includes(groupName)
                ? prev.filter((name) => name !== groupName)
                : [...prev, groupName]
        );
    };

    const debouncedSearchQuery = useDebounce(searchQuery, 400);

    const filteredMasters = useMemo(() => {
        const lowerSearch = debouncedSearchQuery?.toLowerCase();
        return _.chain(Object.entries(mastersList))
            .reduce((acc, [groupName, items]) => {
                const groupMatches = groupName?.toLowerCase().includes(lowerSearch);
                const filteredItems = _.filter(items, item =>
                    item?.display_name.toLowerCase().includes(lowerSearch)
                );
                if (groupMatches || filteredItems?.length > 0) {
                    acc[groupName] = filteredItems?.length > 0 ? filteredItems : items;
                }
                return acc;
            }, {})
            .pairs()
            .sortBy(([groupName]) => groupName?.toLowerCase())
            .reduce((acc, [groupName, items]) => {
                acc[groupName] = _.sortBy(items, 'display_name');
                return acc;
            }, {})
            .value();
    }, [mastersList, debouncedSearchQuery]);


    return useMemo(() => ({
        handleCreateMaster, loader, mastersList, handleColumnList, renameMaster, setshowDelete,
        isColDelete, showGrid, icons, handleComponent, masterComponent,
        handleMasterConfig, currentVisibleMaster, columnDefs, rowData, gridRefs, isMasterCall,
        handleConfigComponent, showCreatePopup, onHide, tableNameOptions, searchQuery, setSearchQuery,
        isNewMaster, currentMaster, groupOptions, handleUpsertMaster, showDelete, sideOpen, setSideOpen,
        deleteMaster, deleteColumn, currentData, listLoader, onCellValueChanged, gridApiRef, handleChange, tableData, expandedGroups, toggleGroup, filteredMasters
    }), [handleCreateMaster, loader, mastersList, handleColumnList, renameMaster, setshowDelete,
        isColDelete, showGrid, icons, handleComponent, masterComponent, searchQuery, setSearchQuery,
        handleMasterConfig, currentVisibleMaster, columnDefs, rowData, gridRefs, isMasterCall,
        handleConfigComponent, showCreatePopup, onHide, tableNameOptions,
        isNewMaster, currentMaster, groupOptions, handleUpsertMaster, showDelete, sideOpen, setSideOpen,
        deleteMaster, deleteColumn, currentData, listLoader, onCellValueChanged, gridApiRef, handleChange, tableData, expandedGroups, toggleGroup, filteredMasters])
}